import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material';

// Definir los tipos de las props del componente
interface ForgotPasswordModalProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (email: string) => void;
    setEmailForPasswordRecovery: (email: string) => void;
}

const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = ({
    open,
    onClose,
    onSubmit,
    setEmailForPasswordRecovery
}) => {
    const [email, setEmail] = useState('');

    const handleSubmit = () => {
        if (email) {
            setEmailForPasswordRecovery(email); // Establece el email en el estado global
            onSubmit(email); // Llama a la función para enviar el correo de recuperación
        } else {
            alert('Por favor ingresa un correo válido');
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Recuperar Contraseña</DialogTitle>
            <DialogContent>
                <TextField
                    label="Correo electrónico"
                    fullWidth
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} color="primary">
                    Enviar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ForgotPasswordModal;
